import React from "react";
import { FaYoutube, FaInstagram, FaGithub, FaTwitter, FaLinkedin } from 'react-icons/fa';
import '../styles/footer.scss';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-section">
        <h1>NextGen Tech</h1>
        <p>&copy; {new Date().getFullYear()} All rights reserved</p>
      </div>

      <div className="footer-section">
        <h5>Follow Us</h5>
        <div className="social-links">
          <a href="https://youtube.com" target="_blank" rel="noopener noreferrer">
            <FaYoutube /> Youtube
          </a>
          <a href="https://instagram.com" target="_blank" rel="noopener noreferrer">
            <FaInstagram /> Instagram
          </a>
          <a href="https://github.com/sambanna07" target="_blank" rel="noopener noreferrer">
            <FaGithub /> Github
          </a>
          <a href="https://twitter.com" target="_blank" rel="noopener noreferrer">
            <FaTwitter /> Twitter
          </a>
          <a href="https://www.linkedin.com/in/samundarsinghrathore" target="_blank" rel="noopener noreferrer">
            <FaLinkedin /> LinkedIn
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
